module.exports = __webpack_public_path__ + "img/襄阳市中西医结合医院.0f1c1675.png";